import trackingSystem from '~/modules/tracking-system/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    ...trackingSystem,
];

export default routes;
